var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 10,
    viewBox: "0 0 92 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2756 1.7417C34.658 3.38804 30.503 10.4879 29.2976 9.9734C22.5475 7.0923 7.9551 6.02905 1.50268 5.85756C0.0136685 5.34308 -1.67388 3.79963 3.48803 1.7417C9.94042 -0.830705 29.2976 -0.316224 32.2756 1.7417Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7244 1.7417C57.342 3.38804 61.497 10.4879 62.7024 9.9734C69.4525 7.0923 84.0449 6.02905 90.4973 5.85756C91.9863 5.34308 93.6739 3.79963 88.512 1.7417C82.0596 -0.830705 62.7024 -0.316224 59.7244 1.7417Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsD);
export default __webpack_public_path__ + "static/media/Brows D.1af76352d869a60c86e6e9b9113cb130.svg";
export { ForwardRef as ReactComponent };